export default __webpack_public_path__ + "8a5120204d4e16b1ceeb4a4035f9a742.jpg";